import React, { useContext, useState, forwardRef } from "react";
import "./subscribeOrSharePopup.css";
import { Context } from "../../context/Context";

const SubscribeOrSharePopup = forwardRef(({ onClose }, ref) => {
  const { userViews } = useContext(Context);
  const [isClosing, setIsClosing] = useState(false);

  const rawRemaining = 3 - Number(userViews);

  if (isNaN(rawRemaining)) {
    console.warn("Invalid userViews value:", userViews);
  }

  const remaining = isNaN(rawRemaining) ? 0 : Math.max(0, rawRemaining);
  const hasReachedLimit = remaining === 0;

  const handleClose = () => {
    if (isClosing) return;
    setIsClosing(true);
    setTimeout(() => {
      if (hasReachedLimit) {
        window.location.href = "/subscribe";
      } else {
        onClose();
      }
    }, 300);
  };

  const subscribe = () => {
    window.location.href = "/subscribe"; // Redirect to the subscribe page, change URL accordingly
  };

  return (
    <>
      <div className="popup-wrapper" onClick={handleClose}>
        <div
          className={`popup ${isClosing ? "closing" : ""} ${hasReachedLimit ? "limit-reached" : ""}`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="popup-content" ref={ref}>
            <button className="close-popup-btn" onClick={handleClose}>
              &times;
            </button>
            {/* <img
              src={process.env.REACT_APP_AWS_S3_IMAGE_FRONTEND_URL + "/bottom_image.jpg"}
              alt="Image"
              className="popup-image"
            /> */}
            <div className="popup-text">
              {/* <img
                src={process.env.REACT_APP_AWS_S3_IMAGE_FRONTEND_URL + "/flowlogo1.png"}
                alt="Logo"
                className="popup-logo"
              /> */}
              <p style={{fontSize:"28px", fontWeight:"400", padding: "10px 0"}}>
                {hasReachedLimit
                  ? "You’ve reached your limit of free article views."
                  : `You have ${remaining} free article view${remaining !== 1 ? "s" : ""} remaining.`}
              </p>
              <p style={{fontSize:"22px", fontWeight:"400", padding: "10px 0"}}>
                Subscribe now to explore our entire library of ad-free content!
              </p>
              <div style={{ display: "flex" }}>
                <button className="button-pop3" onClick={subscribe}>Subscribe Now!</button>
              </div>
            </div>
          </div>
        </div>
      </div> 
    </>
  );
});

export default SubscribeOrSharePopup;
